<template>
  <div class="service-container" :style="{
      backgroundImage: `url(${bannerInfo.img})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }">
    <div class="service-title">服务案例</div>
    <div class="service-list">
      <div class="service-item" v-for="item in serviceList" :key="item.id">
        <div class="service-item-ing">
          <imgContainer :src="item.caseCover" />
        </div>
        <div class="service-item-info">
          <div class="service-item-name" :title="item.caseName">{{handleChara(item.caseName,16)}}</div>
          <div class="service-item-txt" :title="item.caseIntroduction">{{handleChara(item.caseIntroduction,92)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {handleChara} from "@/utils/title";
import {ref} from "vue";
import {getServiceCaseList} from "@/api/apiNews";
import {getBannerList} from "@/api/apiHome";
import imgContainer from '@/components/imgContainer/index.vue'

const serviceList=ref([])
const bannerInfo=ref({})
const queryServiceCaseList = async () => {
  const {code, data} = await getServiceCaseList();
  if (code === 200) {
    serviceList.value = data?.length>3 ? data.slice(0,3) : data;
  }
}
const queryBannerList = async () => {
  const {code, data} = await getBannerList(4)
  if (code === 200) {
    bannerInfo.value = data && data.length>0 ? data[0] : {}
  }
}
queryBannerList()
queryServiceCaseList()
</script>

<style lang="scss" scoped>
.service-container {
  margin: 50px 0;
  padding: 20px 0;
  width: 100%;
}

.service-title {
  width: 1200px;
  margin: 0 auto;
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  position: relative;
  text-align: center;
}

.service-title::after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 4px;
  background: #0048A9;
  border-radius: 2px;
  transition: all 0.3s ease;
}
.service-list {
  width: 1200px;
  margin: 50px auto 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}
.service-item{
  width: 380px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0 2px 14px 0 rgba(0,0,0,0.09);
  .service-item-ing{
    width: 380px;
    height: 244px;
    object-fit: cover;
  }
  .service-item-info{
    padding: 14px 15px 22px 15px;
  }
  .service-item-name{
    font-weight: bold;
    font-size: 20px;
    color: #242424;
    margin-top: 8px;
    margin-bottom: 14px;
  }
  .service-item-txt{
    font-size: 18px;
    color: #797979;
    height: 120px;
  }
}
</style>
